import React from "react";
import { Tabs, Tab } from "@heroui/react";
import StakingTable from "../staking-table";
import NftStakingTab from "../nft-staking-tab";
import { useNavigate } from "react-router-dom";
import { isUserLoggedIn } from "../../../redux/reducer/user_reducer";
import { useSelector } from "react-redux";
import LoginRequired from "../../Login-required";

export default function StakingTabsComponent() {
  const isLoggedIn = useSelector(isUserLoggedIn);
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-full">
      <Tabs
        aria-label="Staking Options"
        variant="underlined"
        classNames={{
          tabList: "mx-auto mb-8",
          tab: "text-gray-400 font-semibold",
          tabSelected: "text-black font-bold",
          cursor: "bg-yellowbuy"
        }}
      >
        <Tab key="nft_staking" title="NFT STAKING">
          <div className="w-full border border-[#C2C2C2] px-4 lg:px-8 py-6 rounded-xl">
            {!isLoggedIn ? (
              <LoginRequired
                description="Please log in to access NFT staking features and manage your digital assets."
                onLogin={() => navigate("/login")}
                onSignup={() => navigate("/sign-up")}
              />
            ) : (
              <NftStakingTab />
            )}
          </div>
        </Tab>

        <Tab key="baf_staking" title="BAF STAKING">
          <div className="w-full border border-[#C2C2C2] px-4 lg:px-8 py-6 rounded-xl">
            {!isLoggedIn ? (
              <LoginRequired
                description="Please log in to access BAF token staking features and manage your staking plans."
                onLogin={() => navigate("/login")}
                onSignup={() => navigate("/sign-up")}
              />
            ) : (
              <StakingTable />
            )}
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}
